export default __webpack_public_path__ + "static/media/facebook_icon.1f7cdc52.svg";